import { render } from "./legoButton.vue?vue&type=template&id=69851338"
import script from "./legoButton.vue?vue&type=script&lang=js"
export * from "./legoButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoButton/legoButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69851338"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69851338', __exports__)) {
    api.reload('69851338', __exports__)
  }
  
  module.hot.accept("./legoButton.vue?vue&type=template&id=69851338", () => {
    api.rerender('69851338', render)
  })

}


export default __exports__